import Keycloak from 'keycloak-js'

function getCurrentFormHash() {
  const hash = window.location.hash
  // Remove leading # and / if present (e.g., #/wbf-seco-beschwerdeformular -> wbf-seco-beschwerdeformular)
  const cleaned = hash ? hash.substring(1).replace(/^\//, '') : ''
  // Remove query parameters (e.g., wbf-seco-beschwerdeformular?captcha=turnstile -> wbf-seco-beschwerdeformular)
  return cleaned.split('?')[0]
}

function isAnonymousForm(config) {
  const currentHash = getCurrentFormHash()
  const anonymousForms = config.anonymousForms
  if (!anonymousForms) {
    return false
  }
  // Handle both comma-separated string and array formats
  const formsList = typeof anonymousForms === 'string'
    ? anonymousForms.split(',').map(f => f.trim())
    : anonymousForms
  return formsList.includes(currentHash)
}

function renderApp() {
  document.querySelector('body').innerHTML = `
<main>
  <div id="mainheader">
    <eform-frontend-header></eform-frontend-header>
    <eform-frontend-horizontal-navigation></eform-frontend-horizontal-navigation>
  </div>
  <div id="maincontent">
    <isceco-message></isceco-message>
    <eform-frontend-main-view></eform-frontend-main-view>
    <isceco-scroll-top></isceco-scroll-top>
  </div>
  <div id="mainfooter">
    <eform-frontend-footer></eform-frontend-footer>
  </div>
</main>
  `
}

// Initialize the application
fetch('./config/config.json', {cache: 'reload'})
  .then(res => res.json())
  .then(config => {
    // Store config globally for use in other parts of the application
    window.eformConfig = config

    if (isAnonymousForm(config)) {
      window.keycloak = null
      window.isAnonymousAccess = true
      window.hasRole = () => false
      renderApp()

      // redirect to login if user navigates to a non anonym page
      window.addEventListener('hashchange', () => {
        if (!isAnonymousForm(config)) {
          window.location.reload()
        }
      })
    } else {
      window.isAnonymousAccess = false
      window.keycloak = new Keycloak({
        url: config.ssoUrl,
        realm: config.ssoRealm,
        clientId: config.ssoClient
      })

      window.keycloak.init({
        onLoad: 'login-required',
        promiseType: 'native',
        checkLoginIframe: false,
        pkceMethod: 'S256'
      }).then(authenticated => {
        renderApp()
      })

      // used for Global Logout context
      window.keycloak.onTokenExpired = () => {
        keycloak.updateToken(-1)
          .catch(function () {
            console.error('Failed to refresh the token, or the session has expired') // NOSONAR
            keycloak.login()
          })
      }
    }
  })
